import React, { FC } from 'react';
import { GlobalStylesHTML } from 'src/components/GlobalStyles';

import { RootState, useSelector } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { ShortAnswerSurveyStyles } from './initStyles';

const ShortAnswerSurveyHTML: FC = () => {
  const templateId = useSelector(
    (state: RootState) => state.template.templateId
  );
  const templateTitle = useSelector(
    (state: RootState) => state.template.templateTitle
  );
  const hash = useSelector((state: RootState) => state.imageUpload.hash);

  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );

  const text = useSelector((state: RootState) => state.editText.text);
  const btnText = useSelector((state: RootState) => state.buttons.btnText);

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);
  const logCustom = useSelector(
    (state: RootState) => state.trackings.logCustom
  );

  const style = `
    .root_view {
      ${
        bg?.background === 'image'
          ? `background-image: url(${bgImage?.background?.[0]})`
          : `background: ${bgColor?.background?.[0]}`
      };

      .back_btn {
        opacity: 0;
      }

      .logo_inner button {
        background-image: url(${bgImage?.logo?.[0]});
      }
  
      .survey_button {
        opacity: 0;
      }
      .survey_action {
        opacity: 1;
      }
    }

    .root_view_0201 {
      ${
        bg?.background_0201 === 'image'
          ? `background-image: url(${bgImage?.background_0201?.[0]})`
          : `background: ${bgColor?.background_0201?.[0]}`
      };

      .logo_inner button {
        background-image: url(${bgImage?.logo_0201?.[0]});
      }
    }
  `;

  const html = `
    <div class="root_view root_view_0101">
      <div class="liquid">
        <p class="user_id">{{\${user_id}}}</p>
        <p class="email_address">{{\${email_address}}}</p>
        <p class="first_name">{{\${first_name}}}</p>
        <p class="last_name">{{\${last_name}}}</p>
      </div>
      <div class="template">
        <div class="center_horizon top_wrapper">
          <button class="back_btn"></button>
          <button class="close_btn"></button>
        </div>
        <div class="center_wrapper">
          <div class="title">
            <div class="title_inner">
              ${changeEnterHTML(text?.title?.[0])}
            </div>
          </div>
          <div class="logo">
            <button></button>
          </div>
          <div class="survey_wrapper"></div>
          <textarea
            class="textarea"
            placeholder="${btnText?.text_area?.[0]}"
          ></textarea>
        </div>
        <div class="center_horizon bottom">
          <button class="left_button">
            ${btnText?.left_button?.[0]}
          </button>
          <button class="right_button">
            ${btnText?.right_button?.[0]}
          </button>
        </div>
      </div>
    </div>

    <div class="root_view root_view_0201">
      <div class="template">
        <div class="center_horizon top_wrapper">
          <div></div>
          <button class="close_btn"></button>
        </div>
        <div class="center_wrapper">
          <div class="title">
            <div class="title_inner">
              ${changeEnterHTML(text?.title_0201?.[0])}
            </div>
          </div>
          <div class="logo">
            <button></button>
          </div>
          <div class="sub_title">
            <div class="sub_title_inner">
              ${changeEnterHTML(text?.sub_title_0201?.[0])}
            </div>
          </div>
        </div>
        <div class="center_horizon bottom">
          <button class="button">
            ${btnText?.button_0201?.[0]}
          </button>
        </div>
      </div>
    </div>
  `;

  const option_list = btnText?.option_button
    ?.map((multi_survey: any, currentIndex: number) =>
      multi_survey
        ?.map(
          (survey: any, idx2: number) => `
            <div id="${idx2}" class="survey survey_click survey_${currentIndex}">
              <span class="survey_radius">
                <div id="${idx2}" class="survey_button survey_button_${currentIndex} survey_button_${currentIndex}_${idx2}"></div>
              </span>
              <p class="survey_text_${currentIndex}_${idx2}">${survey}</p>
            </div>
            ${
              idx2 !== btnText?.option_button?.[currentIndex]?.length - 1
                ? `<hr class="hr survey survey_${currentIndex}" />`
                : ''
            }
          `
        )
        .join('')
    )
    .join('');

  const js = `
    document.addEventListener("DOMContentLoaded", function() {
      let currentIndex = 0;
      let bg = ${JSON.stringify(bg)};
      let bgImage = ${JSON.stringify(bgImage)};
      let bgColor = ${JSON.stringify(bgColor)};
      let text = ${JSON.stringify(text)};
      let btnText = ${JSON.stringify(btnText)};
      let option = \`${option_list}\`;
      $('.survey_wrapper').html(option);
      $('.survey').css("display", "none");
      $('.survey_0').css("display", "flex");
      const changePage = () => {
        $('.back_btn').css("opacity", 1);
        if (currentIndex === 0) $('.back_btn').css("opacity", 0);

        $('.survey').css("display", "none");
        $('.survey_'+currentIndex).css("display", "flex");

        if (bg.background === 'image') $('.root_view').css("background-image", "url("+bgImage.background[currentIndex]+")");
        else $('.root_view').css("background", bgColor.background[currentIndex]);
        $('.logo_inner > button').css("background-image", "url("+bgImage.logo[currentIndex]+")");
        $('.title_inner').text(text.title[currentIndex]);
        $('.textarea').attr("placeholder", btnText.text_area[currentIndex]);
        $('.left_button').text(btnText.left_button[currentIndex]);
        $('.right_button').text(btnText.right_button[currentIndex]);
      }

      let pre_answer = [];
      let idx = -1;
      <!-- 옵션선택 -->
      $('.survey_click').click(function() {
        idx = $(this).attr('id');
        let action = $('.survey_button_' + currentIndex + '_' + idx).hasClass('survey_action');
        
        if (action) {
          $('.survey_button_' + currentIndex + '_' + idx).removeClass('survey_action');
          $('.left_button').removeClass('action');
          pre_answer = [];
        } else {
          $('.survey_button_' + currentIndex).removeClass('survey_action');
          $('.survey_button_' + currentIndex + '_' + idx).addClass('survey_action');
          $('.left_button').addClass('action');
          pre_answer = idx;
        }
      });

      <!-- 닫기 -->
      $('.root_view_0101 .close_btn').click(function() {
        <!-- custom 트래킹 -->
        brazeBridge.logClick(tracking.close[currentIndex]);

        <!-- button 트래킹 -->
        try {
          if (button1.close.indexOf(0) !== -1) {
            brazeBridge.logClick('0');
          }
        } catch (err) {}
        try {
          if (button2.close.indexOf(0) !== -1) {
            brazeBridge.logClick('1');
          }
        } catch (err) {}

        brazeBridge.closeMessage();
      })
      $('.root_view_0201 .close_btn').click(function() {
        <!-- custom 트래킹 -->
        brazeBridge.logClick(tracking.close_0201[0]);

        <!-- button 트래킹 -->
        try {
          if (button1.close_0201.indexOf(0) !== -1) {
            brazeBridge.logClick('0');
          }
        } catch (err) {}
        try {
          if (button2.close_0201.indexOf(0) !== -1) {
            brazeBridge.logClick('1');
          }
        } catch (err) {}

        brazeBridge.closeMessage();
      })

      <!-- 뒤로가기 -->
      $('.back_btn').click(function() {
        let newCurrentIndex = currentIndex - 1;
        if (newCurrentIndex > -1) {
          currentIndex = newCurrentIndex;
          changePage();
        }
      })

      let tracking = ${JSON.stringify(tracking)};
      let button1 = ${JSON.stringify(button1)};
      let button2 = ${JSON.stringify(button2)};
      let logCustom = ${JSON.stringify(logCustom)};
      <!-- 앞으로가기 -->
      $('.left_button').click(function() {
        if (pre_answer.length === currentIndex) return;
  
        let newCurrentIndex = currentIndex + 1;
        <!-- custom 트래킹 -->
        brazeBridge.logClick(tracking.left_button[currentIndex]);

        <!-- button 트래킹 -->
        try {
          if (button1.left_button.indexOf(currentIndex) !== -1) {
            brazeBridge.logClick('0');
          }
        } catch (err) {}
        try {
          if (button2.left_button.indexOf(currentIndex) !== -1) {
            brazeBridge.logClick('1');
          }
        } catch (err) {}

        if (newCurrentIndex < bgImage.background.length) {
          currentIndex = newCurrentIndex;
          changePage();
        } else {
          <!-- liquid 값 -->
          let user = {};
          user.user_id = $('.user_id').text();
          user.email = $('.email_address').text();
          user.first_name = $('.first_name').text();
          user.last_name = $('.last_name').text();

          let answer = [];
          for (let i = 0; i < pre_answer.length; i++) {
            <!-- 설문조사 최종 값 -->
            let j = pre_answer[i];
            let selected_text = $('.survey_text_' + i + '_' + j).text();
            if (j == btnText.option_button[i].length - 1) selected_text = $('.textarea').val();

            answer.push({
              user_id: user.user_id,
              question: text.title[i],
              selected: selected_text,
            });

            <!-- custom 로그 -->
            selected_text = $('.survey_text_' + i + '_' + j).text();
            if (logCustom.type[i][j] === "attribute") {
              appboyBridge.getUser().setCustomUserAttribute(logCustom.option_button[i][j], selected_text);
            }
            if (logCustom.type[i][j] === "event") {
              appboyBridge.logCustomEvent(log_custom.option_button[i][j]);
            }

            <!-- custom 트래킹 -->
            brazeBridge.logClick(tracking.option_button[i][j]);

            <!-- button 트래킹 -->
            try {
              if (button1.option_button.indexOf(i+":"+j) !== -1) {
                brazeBridge.logClick('0');
              }
            } catch (err) {}
            try {
              if (button2.option_button.indexOf(i+":"+j) !== -1) {
                brazeBridge.logClick('1');
              }
            } catch (err) {}
          }

          <!-- 설문조사 최종 값 보내기 -->
          try {
            $.ajax({
              type : 'post',
              url : '${process.env.REACT_APP_API_URL}/events',
              async : true,
              headers : {
                "Content-Type" : "application/json"
              },
              data : JSON.stringify({
                "template_id": "${templateId}" !== "undefined" ? "${templateId}" : templateId,
                "hash": "${hash}" !== "null" ? "${hash}" : hash,
                "template_name": "${templateTitle}",
                "user": user,
                "client_submit_timestamp": new Date().getTime(),
                "attributes": answer
              }),
              success : function(result) {
              },    
              error : function(request, status, error) {     
                console.log(error)    
              }
            })
          } catch (err) {}
          
          $('.root_view').css('display', 'none');
          $('.root_view_0201').css('display', 'block');
        }
      });

      $('.right_button').click(function() {
        <!-- custom 트래킹 -->
        brazeBridge.logClick(tracking.right_button[currentIndex]);

        <!-- button 트래킹 -->
        try {
          if (button1.right_button.indexOf(0) !== -1) {
            brazeBridge.logClick('0');
          }
        } catch (err) {}
        try {
          if (button2.right_button.indexOf(0) !== -1) {
            brazeBridge.logClick('1');
          }
        } catch (err) {}

        $('.root_view').css('display', 'none');
        $('.root_view_0201').css('display', 'block');
      })

      $('.button').click(function() {
        <!-- custom 트래킹 -->
        brazeBridge.logClick(tracking.button_0201[0]);

        <!-- button 트래킹 -->
        try {
          if (button1.button_0201.indexOf(0) !== -1) {
            brazeBridge.logClick('0');
          }
        } catch (err) {}
        try {
          if (button2.button_0201.indexOf(0) !== -1) {
            brazeBridge.logClick('1');
          }
        } catch (err) {}

        window.location = '${deeplink?.button_0201}';
        brazeBridge.closeMessage();
      })
    });
  `;

  return (
    <>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <style
        dangerouslySetInnerHTML={{
          __html: GlobalStylesHTML() + ShortAnswerSurveyStyles() + style
        }}
      />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};
export default ShortAnswerSurveyHTML;
